import { render } from "./manage-role.vue?vue&type=template&id=115723ca&scoped=true"
import script from "./manage-role.vue?vue&type=script&lang=js"
export * from "./manage-role.vue?vue&type=script&lang=js"

import "./manage-role.vue?vue&type=style&index=0&id=115723ca&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115723ca"]])

export default __exports__